import { react } from "../../../omnia"
import { TerramapContext } from "../../context"

import FormGroup = react.FormGroup
import NumericInput = react.NumericInput
import DatePicker = react.DatePicker
import Checkbox = react.Checkbox
import { Parameters } from "../../types"

interface Props {
    parameters: Parameters
}

export function SetParameters({ parameters: p }: Props) {

    const { dispatch } = React.useContext(TerramapContext)

    if (!p) return null

    const dateValue = p.date ? new Date(p.date) : undefined

    const set = (update: Partial<Parameters>) => dispatch({ type: "updateParameters", update })
    const setYear = (year: number) => set({ year })
    const setDate = (date: Date) => set({ date: date?.toISOString() })
    const setMorganAnalysis = (morganAnalysis: boolean) => set({ morganAnalysis })

    return <div className="section parameters">

        <h2>
            <i className="fas fa-pen" />
            Edit parameters
        </h2>

        <FormGroup label="Cropping year">
            <NumericInput value={p.year} setValue={setYear} min={2010} />
        </FormGroup>

        <DatePicker label="Sampling date" date={dateValue} setDate={setDate}>
        </DatePicker>

        <FormGroup>
            <Checkbox checked={p.morganAnalysis} setChecked={setMorganAnalysis}>
                Morgan analysis
            </Checkbox>
        </FormGroup>

    </div>

}
